import React from 'react';
import ComparisonOverlay from './ComparisonOverlay';
import PropTypes from 'prop-types';

/**
 * DataComparisonTableMobile.
 * Table for comparing items in a product package.
 *
 * @author  Manny
 * @param   {Array}       props.data            Product package's data.
 * @param   {String}      props.industryKey     Name of the industry.
 * @param   {Object}      props.industryPackage List of packages for the industry.
 * @param   {String}      props.packageKey      Name of the package.
 * @param   {String}      props.type            Type of product package data.
 * @returns {JSX.Element} The component markup.
 */

const DataComparisonTableMobile = ({ data, industryKey, industryPackage, packageKey, type }) => {
  let dataContent = null;
  const homeprezzoKeys = [
    'smart_move',
    'homeprezzo_agency',
    'homeprezzo_agency_large',
    'homeprezzo_agent',
    'homeprezzo_small_agency'
  ];
  const renderTitle = (key, title, description) => {
    return <>
      <div className="flex">
        <div className="column semi-bold title-column"id={key}>
          {title}
        </div>
        <div className="column semi-bold tooltip-column text-right">
          {description && <ComparisonOverlay tooltip={description}/>}
        </div>
      </div>
    </>
  }

  if (data !== undefined) {
    dataContent = Object.keys(data).map(function (singlePackage) {
      let item = data[singlePackage];
      if (
        (item.conditional === true &&
          industryKey !== undefined &&
          ((industryKey === 'mortgage_brokers_and_financial_planners' &&
            (item.key === 'homeprezzo_agent_lite' || item.key === 'homeprezzo_agent')) ||
            (industryKey === 'real_estate_agencies_and_valuers' &&
              homeprezzoKeys.indexOf(item.key) > -1))) ||
        item.conditional === undefined
      ) {
        let subItem = industryPackage[packageKey];
        return (
          <div className='row table-padding' key={item.key}>
            <div className='col-xs-9'>
              {renderTitle(`item_title_${item.key}`, item.title, item.description)}
            </div>
            <div className='col-xs-3 comparison-table-align' key={subItem.key}>
              {subItem.features[type] &&
                subItem.features[type][item.key] !== 'N/A' &&
                subItem.features[type][item.key] !== 'Metrolpolitan Area' && (
                  <span>{subItem.features[type][item.key]}</span>
                )}
              {subItem.features[type] && subItem.features[type][item.key] === 'Metrolpolitan Area' && (
                <span>
                  <span>{subItem.features[type][item.key]}</span>
                  <p className='sub-text'>Enquire for national</p>
                </span>
              )}
              {subItem.features[type] && subItem.features[type][item.key] === 'N/A' && (
                <span>
                  <i className='fa fa-minus tan-text' aria-hidden='true'></i>
                </span>
              )}
            </div>
          </div>
        );
      } else {
        return <div key={item.key}></div>;
      }
    });
  }

  return <div>{dataContent}</div>;
};

DataComparisonTableMobile.propTypes = {
  data: PropTypes.array.isRequired,
  industryKey: PropTypes.string,
  industryPackage: PropTypes.object.isRequired,
  packageKey: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

export default DataComparisonTableMobile;
